var _desc, _style, _desc2, _style2, _path, _path2, _path3, _path4, _text;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSapLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sapiensia-logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 370,
    height: 100,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Sapiensia Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, ":)")), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t@import url('https://fonts.googleapis.com/css2?family=EB+Garamond&display=swap');\n\n\t\tsvg#sapiensia-logo text.logo-text {\n\t\t\tfont-size:37px;\n\t\t\tfont-family:EB Garamond, serif;\n\t\t\tfont-weight:100;\n\t\t\tcolor:white;\n\t\t\tfill:white;\n\t\t\tstroke:white;\n\t\t\ttext-shadow: none;\n\t\t}\n\n\t\t@media only screen and (max-width: 600px) {\n\t\t\tsvg#sapiensia-logo {\n\t\t\t\twidth: 140px;\n\t\t\t\theight: 120px;\n\t\t\t}\n\t\t\tsvg#sapiensia-logo text.logo-text {\n\t\t\t\ttransform: translate(-90px, 51px);\n\t\t\t\tfont-size: 24px;\n\t\t\t}\n\t\t}\n\t")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Sapiensia Logo Standalone") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc2 || (_desc2 = /*#__PURE__*/React.createElement("desc", null, "It symbolises inspiration and love. :)")), _style2 || (_style2 = /*#__PURE__*/React.createElement("style", null, "\n\t\t\t\t.curve {\n\t\t\t\t\tstroke: white;\n\t\t\t\t\tstroke-width: 2px;\n\t\t\t\t\tstroke-linecap: round;\n\t\t\t\t\tfill: transparent;\n\t\t\t\t}\n\t\t\t")), /*#__PURE__*/React.createElement("g", {
    className: "logo-star",
    style: {
      transform: "scale(1.7) rotate(17deg)",
      transformOrigin: "center"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "curve",
    d: "M 50 25 C 50 25, 50 50, 75 50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "curve",
    d: "M 75 50 C 75 50, 50 50, 50 75"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "curve",
    d: "M 50 75 C 50 75, 50 50, 25 50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "curve",
    d: "M 25 50 C 25 50, 50 50, 50 25"
  }))))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "logo-text",
    x: 100,
    y: 63
  }, "Sapiensia")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSapLogo);
export default __webpack_public_path__ + "static/media/sap-logo.ff76d065.svg";
export { ForwardRef as ReactComponent };